type ParagraphTextProps = {
  list: string[];
};

export const ParagraphText = ({ list }: ParagraphTextProps) => (
  <>
    {list.map((item, i) => (
      <p key={i}>{item}</p>
    ))}
  </>
);
